import { createTheme } from "@mui/material";
import {
  MuiButtonOverrides
} from "./componentOverrides";
import { applyPalette } from "./themePalette";
import { applyTypography } from "./themeTypography";
import { deepmerge } from '@mui/utils';


let theme = createTheme({

  shape: {
    borderRadius: 0,
  },
});

theme.components = deepmerge(theme.components, {
  // MuiFormControlLabel: {
  //   defaultProps: {

  //   }
  // },
  // MuiInput: MuiInputOverrides,
  // MuiAccordion: MuiAccordionOverrides,
  // MuiAccordionSummary: MuiAccordionSummaryOverrides,
  // MuiAccordionDetails: MuiAccordionDetailsOverrides,
  // MuiTextField: MuiTextFieldOverrides,
  // MuiGrid: MuiGridOverrides,
  MuiButtonGroup: {
    defaultProps: {
      disableElevation: true
    }
  },
  MuiButton: MuiButtonOverrides
})

theme = applyPalette(theme)
theme = applyTypography(theme)

export default theme